import React from "react";
import styled from "styled-components";

import Header from "./components/Header";
import BuyNowLinks from "./components/BuyNowLinks";
import Trailer from "./components/Trailer";
import WeaponsCarousel from "./components/WeaponsCarousel";

import xmasBorder from "./library/images/kf2-xmas-divider.png";

function App() {
  return (
    <WidescreenStyle>
      <SiteWrapper>
        <Header />
        <BuyNowLinks />
        <Trailer />
        <TextWrapper>
          <h2>Ho Ho Horrors!</h2>
        </TextWrapper>
        <TextWrapper>
          <p>
            Happy holidays from the Horzine team as we present our seasonal
            Yuletide Horrors update! Take a perilous stroll through Sanitarium
            and uncover its dark, ritualistic secrets while dispatching the
            holiday horrors skulking through its maniacal hallways. But don’t
            stop there! You can thwart the Patriarch’s plans to clone a legion
            of Zeds in the Biotics Lab Objective game mode. Seems a bit much to
            get done on top of decorating and gift wrapping? Don’t worry, the
            Horzine team developed a few new handy dandy weapons to knock the
            socks off those pesky, ravenous elves! As you deck the halls with
            guts and blood, wear some holiday cheer with our many new cosmetics
            that’ll put even your own grandmother’s sweater to shame! Tis the
            season to be slaying, and from the Horzine team, we wish you all a
            grand, bloody-good time!
          </p>
        </TextWrapper>
        <DividerWrapper>
          <img src={xmasBorder} alt="Christmas Border" />
        </DividerWrapper>
        <TextWrapper>
          <h2>New Map - Sanitarium</h2>
        </TextWrapper>
        <ImageContainer>
          <img
            src="https://cosmic-s3.imgix.net/a1c8ef30-17ae-11ea-a594-a170ead8b2cb-new-map.jpg"
            alt="New Sanitarium Map"
          />
        </ImageContainer>
        <TextWrapper>
          <ul>
            <li>
              Compatible with Survival, Weekly, Versus Survival, and Endless
              Game Modes
            </li>
            <li>
              Blast away crowds of holiday Zeds as mysterious entities perform a
              dark ritual to summon the great one
            </li>
          </ul>
        </TextWrapper>
        <DividerWrapper>
          <img src={xmasBorder} alt="Christmas Border" />
        </DividerWrapper>
        <TextWrapper>
          <h2>Let The Festivities Begin!</h2>
        </TextWrapper>
        <TextWrapper>
          <p>
            <span class="yellow-text">HRG Incision for the Field Medic:</span>{" "}
            An alteration of the Railgun that fires overcharged, highly-piercing
            bullets and darts. The bullets are capable of shocking Zeds and
            inducing the EMP effect on them. As for the darts, they hit their
            target almost instantly and are capable of healing other players for
            a substantial amount of health. These darts deal more damage than
            standard darts and have the potential to knock down or stumble Zeds
            that are in the way of their path.
          </p>
          <p>
            <span class="yellow-text">HRG Winterbites for the Gunslinger:</span>{" "}
            An alteration of the Spitfires that fires large, nitrogen ice shards
            that explode on impact, dealing damage and applying the freeze
            affliction to any Zeds inside the explosion radius. Trader price is
            325 Dosh for single and 650 Dosh for duals.
          </p>
        </TextWrapper>
        <WeaponsCarousel />
        <TextWrapper>
          <p>
            <span class="yellow-text">Mosin Nagant for the Sharpshooter:</span>{" "}
            This is a paid DLC weapon. This weapon can be shared amongst players
            through our weapon sharing system. Five-shot, bolt-action, internal
            magazine-fed military rifle. This M91/30 allows a capable
            sharpshooter to fire at distant threats, stab at nearby threats, and
            block and parry damage from incoming threats. Trader price is 1100
            Dosh.
          </p>
          <p>
            <span class="yellow-text">
              Riot Shield & Glock 18 for the SWAT:
            </span>{" "}
            This is a paid DLC weapon. This weapon can be shared amongst players
            through our weapon sharing system. A combination of the Riot Shield
            and Glock 18. The Riot Shield can mitigate most incoming, frontal
            damage only while a player is aiming down the sights. Its bash is
            capable of slamming into multiple Zeds crowding in front of you. The
            Glock 18 is a fully automatic pistol with two fire modes: single and
            automatic. Trader price is 1500 Dosh.
          </p>
        </TextWrapper>
        <DividerWrapper>
          <img src={xmasBorder} alt="Christmas Border" />
        </DividerWrapper>
        <TextWrapper>
          <h2>Coming Down Your Chimney...</h2>
        </TextWrapper>
        <ImageContainer>
          <img
            src="https://cosmic-s3.imgix.net/a1bf7950-17ae-11ea-a8c4-6b69c807b1d7-new-matriarch.jpg"
            alt="New Matriarch"
          />
        </ImageContainer>
        <TextWrapper>
          <p class="yellow-text">New Boss - The Matriarch:</p>
          <p>
            Rachel Clamely returns as the Matriarch. Her pursuit to stop her
            father turned into an overzealous dedication, and she has gone
            through great lengths to contest against him. Her biotech
            modifications have given her a new perspective in life but her mind
            has gone quite mad from it. Nothing will stand in her way, friend or
            foe!
          </p>
        </TextWrapper>
        <DividerWrapper>
          <img src={xmasBorder} alt="Christmas Border" />
        </DividerWrapper>
        <TextWrapper>
          <h2>What's New In Your Stocking?</h2>
        </TextWrapper>
        <ImageContainer>
          <img
            src="https://cosmic-s3.imgix.net/a1fa5f70-17ae-11ea-a8c4-6b69c807b1d7-new-cosmetics.jpg"
            alt="New Cosmetics"
          />
        </ImageContainer>
        <TextWrapper>
          <p class="yellow-text">Dosh Vault:</p>
          <ul>
            <li>HMTech-501 Grenade Rifle | Vault | Vosh | Precious</li>
            <li>MKb.42 | Vault | Vosh | Precious</li>
            <li>Doomstick | Vault | Vosh | Precious</li>
            <li>Seeker Six | Vault | Vosh | Precious</li>
          </ul>
        </TextWrapper>
        <TextWrapper>
          <p class="yellow-text">New Steam Achievements:</p>
          <ul>
            <li>Defeating the Matriarch</li>
            <li>Sanitarium and its collectibles</li>
            <li>Biotics Lab Objective game mode completion</li>
          </ul>
        </TextWrapper>
        <TextWrapper>
          <p class="yellow-text">
            Time-limited Objectives, Tickets, and Cosmetics:
          </p>
          <ul>
            <li>
              Matriarch, Sanitarium, and Biotics Lab seasonal objectives to earn
              the FN FAL | Jaeger | Dynamic weapon skin
            </li>
            <li>Christmas Event Tickets</li>
            <li>Christmas Cosmetics</li>
          </ul>
        </TextWrapper>
        <TextWrapper>
          <p class="yellow-text">Zedconomy:</p>
          <ul>
            <li>Mosin Nagant Weapon Bundle</li>
            <li>Riot Shield & G18 Weapon Bundle</li>
            <li>Grim Treatments Weapon Bundle</li>
            <li>Yuletide Horrors Weapon Bundle</li>
            <li>Jaeger Weapon Skin Double Pack</li>
            <li>Foster’s Favorites Weapon Skin Pack</li>
            <li>Santa’s Helper Outfit Bundle</li>
          </ul>
          <p class="yellow-text">
            Added Bronze, Silver, and Gold Bundle Packs for:
          </p>
          <ul>
            <li>Premium Christmas Tickets</li>
            <li>Emote Crate | Series #3</li>
            <li>Jaeger Weapon Skin Encrypted USB</li>
            <li>Horzine Supply Crate | Series #12 (Deepstrike)</li>
          </ul>
        </TextWrapper>
        <ExtraPadding />
        <Copyright>
          <h4 style={{ margin: "15px 0" }}>
            © 2019 Tripwire Interactive - All Rights Reserved
          </h4>
        </Copyright>
      </SiteWrapper>
    </WidescreenStyle>
  );
}
export default App;

const WidescreenStyle = styled.div`
  background: linear-gradient(#235d15, #993019, #235d15);
`;

const SiteWrapper = styled.div`
  max-width: 1920px;
  margin: auto;

  h2,
  p,
  li {
    font-family: "Titillium Web", sans-serif;
    letter-spacing: 1px;
  }
`;

const TextWrapper = styled.div`
  margin: 40px 0;
  padding: 0 20vw;

  .yellow-text {
    color: #fde704;
  }

  .image {
    display: flex;
    justify-content: center;
  }

  img {
    width: 70%;
    height: 70%;
  }

  h2 {
    font-family: "BICUBIK", sans-serif;
    font-size: 38px;
    letter-spacing: 3px;
    text-align: center;
    color: #fde704;
    text-shadow: 1px 1px #000000;
    padding: 5vh 0;
  }

  h3 {
    color: #fde704;
    text-shadow: 1px 1px black;
    text-align: left;
    padding: 5px;
    font-size: 18px;
  }

  a {
    color: #fde704;
    text-decoration: none !important;
  }

  a:hover {
    color: #fde704 !important;
    text-decoration: underline !important;
  }

  p,
  li {
    text-shadow: 1px 1px black;
    font-size: 16px;
    color: white;
    text-align: justify;
  }

  @media (max-width: 1608px) {
    padding: 0 15vw;
  }

  @media (max-width: 1378px) {
    padding: 0 10vw;
  }

  @media (max-width: 650px) {
    margin-bottom: 20px;
    padding: 0 5vw;

    img {
      width: 100%;
      height: 100%;
    }

    h2 {
      font-size: 21px;
      letter-spacing: 2px;
    }

    h3 {
      font-size: 15px !important;
    }

    p,
    li {
      text-align: left;
      font-size: 14px;
    }
  }
`;

const DividerWrapper = styled.div`
  margin: 0;
  overflow: hidden;
  img {
    height: 6vh;
    margin-left: 50%;
    transform: translateX(-50%);
    margin-top: 40px;
  }
  @media (max-width: 450px) {
    img {
      height: 5vh;
    }
  }
`;

const ImageContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 10px 20vw 20px 20vw;

  img {
    height: 100%;
    width: 100%;
    border: solid;
    border-width: 2px;
    border-color: #960a0d;
  }

  @media (max-width: 800px) {
    padding: 10px 10vw 20px 10vw;
  }

  @media (max-width: 650px) {
    padding: 10px 5vw 20px 5vw;
  }
`;

const ExtraPadding = styled.div`
  height: 7vh;
`;

const Copyright = styled.div`
  background: black;
  color: white;
  text-align: center;
  padding: 10px 0;

  h4 {
    font-size: 18px;
  }

  @media (max-width: 650px) {
    h4 {
      font-size: 14px;
    }
  }
`;
